import {
  ROOT,
  GET_ALL_ROOMS_INFO,
  ADD_NEW_ROOW,
  UPDATE_ROOM,
  DUPLICATE_ROOM,
  DELETE_ROOM,
  GET_ROOM_DETAIL,
  GET_ROOM_VIEW,
  GET_BED_TYPE,
  GET_ROOM_GROUP,
  GET_ROOM_PARENT_TYPE,
  GET_CHANNEL,
  GET_MARKET,
  UPDATE_ROOM_STATUS,
  GET_ROOM_AMENITIES,
  UPDATE_ROOM_AMENITIES,
  GET_ROOM_IMAGE,
  UPDATE_ROOM_IMAGE,
  VALIDATE_ROOM_CODE,
  VALIDATE_ROOM_PARENT,
  SORT_INDEX_ROOM,
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function getChannel() {
  return fetch(ROOT + GET_CHANNEL, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#region list of rooms
function getMarket() {
  return fetch(ROOT + GET_MARKET, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#region list of rooms
function getRoomParentType() {
  return fetch(ROOT + GET_ROOM_PARENT_TYPE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateRoomStatus(data) {
  return fetch(ROOT + UPDATE_ROOM_STATUS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function getRoomGroup() {
  return fetch(ROOT + GET_ROOM_GROUP, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllRooms(data) {
  return fetch(ROOT + GET_ALL_ROOMS_INFO, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function createRoom(data) {
  return fetch(ROOT + ADD_NEW_ROOW, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateRoom(data) {
  return fetch(ROOT + UPDATE_ROOM, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function duplicateRoom(data) {
  return fetch(ROOT + DUPLICATE_ROOM, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function removeRoom(id) {
  return fetch(ROOT + DELETE_ROOM + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion

//#region room detail
function getRoomDetail(id) {
  return fetch(ROOT + GET_ROOM_DETAIL + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getRoomView() {
  return fetch(ROOT + GET_ROOM_VIEW, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getBedType() {
  return fetch(ROOT + GET_BED_TYPE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function validateRoomCode(data) {
  return fetch(ROOT + VALIDATE_ROOM_CODE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function validateRoomParent(data) {
  return fetch(ROOT + VALIDATE_ROOM_PARENT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#endregion

//#region room amenities
function getRoomAmenities(id) {
  return fetch(ROOT + GET_ROOM_AMENITIES, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateRoomAmenities(id, data) {
  return fetch(
    ROOT + UPDATE_ROOM_AMENITIES + `/${id}`,
    requestOptions.post(data)
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion

//#region room images
function getRoomImages(id) {
  return fetch(ROOT + GET_ROOM_IMAGE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateRoomImages(id, data) {
  return fetch(ROOT + UPDATE_ROOM_IMAGE + `/${id}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function sortIndexRoom(data) {
  return fetch(ROOT + SORT_INDEX_ROOM, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#endregion
export const service = {
  validateRoomParent,
  validateRoomCode,
  getChannel,
  getMarket,
  updateRoomStatus,
  getRoomParentType,
  getRoomGroup,
  getAllRooms,
  createRoom,
  updateRoom,
  duplicateRoom,
  removeRoom,
  getRoomDetail,
  getRoomView,
  getBedType,
  getRoomAmenities,
  updateRoomAmenities,
  getRoomImages,
  updateRoomImages,
  sortIndexRoom
};
